// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Df8a","content":"styles_content__2_eWN"};